const micromags: MicromagItem[] = [
    {
        id: 'saison26-27',
        slug: 'saison26-27',
        url: 'https://microm.ag/saison26-27.json',
        // story: testStory,
    },
];

export default micromags;
